import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Avatar = props => (
  <SvgIcon {...props} viewBox="0 0 28 28">
    <path
      transform="translate(3.5, 3.5)"
      d="m10.521 5.4207c2.2195 0 3.9909 1.814 3.9909 4.0122 0 1.3872-0.72561 2.625-1.7927 3.3293 2.689 0.74695 4.5244 2.7317 4.5884 5.0152-1.4742 1.3854-3.3918 2.3421-5.5069 2.6241 1.7878-0.27836 3.4077-1.1331 4.6601-2.3573-0.055774-2.0691-1.6546-3.8674-3.9971-4.5442h-3.8484c-2.3611 0.6768-3.9599 2.4751-4.0157 4.5442 1.3192 1.306 3.0461 2.1739 4.9483 2.3982-2.2529-0.21474-4.3012-1.1849-5.8562-2.665 0.064024-2.2835 1.8994-4.2683 4.6098-5.0152-1.0884-0.72561-1.7927-1.9421-1.7927-3.3293 0-2.1982 1.7927-4.0122 4.0122-4.0122zm-0.021342 1.0793c-1.6569 0-3 1.3431-3 3 0 1.6569 1.3431 3 3 3 1.6569 0 3-1.3431 3-3 0-1.6569-1.3431-3-3-3zm0-6.5c5.8049 0 10.5 4.6951 10.5 10.5 0 5.8049-4.6951 10.5-10.5 10.5-5.8049 0-10.5-4.6951-10.5-10.5 0-5.8049 4.6951-10.5 10.5-10.5zm0 1c-5.252 0-9.5 4.248-9.5 9.5 0 5.252 4.248 9.5 9.5 9.5 5.252 0 9.5-4.248 9.5-9.5 0-5.252-4.248-9.5-9.5-9.5z"
    />
  </SvgIcon>
);

export default Avatar;
